// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"SectionSocialLinks_iconContainer__H7R8g"};